<template>
    <DsFormGroup theme="dark" :name v-slot="{ class: itemClass }">
        <DsCheckboxOption
            v-for="item in options"
            :key="item.guid"
            :class="itemClass"
            :value="item.guid"
            :label="item.name"
            :id="`${name}-${item.guid}`"
            :name
            v-model="modelValue"
            @update:model-value="() => filterChanged(item)"
            class="games-filter__checkbox"
        />
    </DsFormGroup>
</template>

<script lang="ts" setup>
import { GamesFilterCategory } from "@/games/models/games-filter-options";
import { GamesFilterType } from "@/games/models/games-filter-type";
import DsCheckboxOption from "@sazka/design-system/src/forms/components/ds-checkbox-option.vue";
import DsFormGroup from "@sazka/design-system/src/forms/components/general/ds-form-group.vue";

const emit = defineEmits(["filterChanged"]);

defineProps<{
    name?: GamesFilterType;
    options: GamesFilterCategory[];
}>();

const modelValue = defineModel<string[]>();

const filterChanged = (category: GamesFilterCategory) => {
    emit("filterChanged", category);
};
</script>
